import React from 'react';
import CalculatorLayout from '../../components/layout/CalculatorLayout';
import AppHeader from '../../components/AppHeader/AppHeader';
import {Calculator} from "../../components/Calculator/Calculator";


const CalculatorPage: React.FC = () => {
    return (
        <CalculatorLayout>
            <AppHeader />
            <Calculator />
        </CalculatorLayout>
    );
};

export default CalculatorPage; 